import { FC, PropsWithChildren, createContext, useContext } from 'react';
import { useUserAndEventFields } from '../../../../../hooks/useUserAndEventFields';
import { MergeTag } from '../types';
import { dedupeMergeTags } from '../utils/dedupeMergeTags';
import { convertMappingToMergeTag } from '../utils/convertMappingToMergeTag';
import { sortByFieldName } from '../utils/sortByFieldName';

type MergeTagsContextState = {
  mergeTags: MergeTag[];
  isLoading: boolean;
  didError: boolean;
};

export const defaultState: MergeTagsContextState = {
  didError: false,
  isLoading: false,
  mergeTags: [],
};

const MergeTagsContext = createContext(defaultState);

export const MergeTagsContextProvider: FC<PropsWithChildren<NonNullable<unknown>>> = ({
  children,
}) => {
  const { data, isLoading, isError: didError } = useUserAndEventFields();
  const mergeTags = data.map(convertMappingToMergeTag);
  const sortedDedupedMergeTags = dedupeMergeTags(mergeTags).sort(sortByFieldName);

  return (
    <MergeTagsContext.Provider value={{ mergeTags: sortedDedupedMergeTags, isLoading, didError }}>
      {children}
    </MergeTagsContext.Provider>
  );
};

export const useMergeTagsContext = () => useContext(MergeTagsContext);
